<template>
  <el-tooltip
    :disabled="disabled"
    effect="dark"
    popper-class="ellipsis-text-tooltip"
    :content="content"
    placement="bottom-start"
  >
    <p ref="container" style="overflow:hidden; white-space: nowrap; text-overflow: ellipsis; outline: none">
      <slot />
    </p>
  </el-tooltip>
</template>
<script>
import Utils from '@/utils'
import _ from 'lodash'
export default {
  name: 'EllipsisText',
  props: {
    content: {
      type: String,
      default () {
        return ''
      }
    }
  },
  data () {
    return {
      disabled: true
    }
  },
  watch: {
    content () {
      this.$nextTick(() => {
        this.disabled = this.$refs.container ? this.$refs.container.clientWidth >= this.$refs.container.scrollWidth : true
      })
    }
  },
  beforeMount () {
    this.resizeHandler = _.debounce(() => {
      this.disabled = this.$refs.container ? this.$refs.container.clientWidth >= this.$refs.container.scrollWidth : true
    }, 400)
  },
  mounted () {
    Utils.EventBinder.bind(window, 'resize', this.resizeHandler)
    this.$nextTick(() => {
      this.disabled = this.$refs.container ? this.$refs.container.clientWidth >= this.$refs.container.scrollWidth : true
    })
  },
  beforeDestroy () {
    Utils.EventBinder.unbind(window, 'resize', this.resizeHandler)
  }
}
</script>
<style lang="stylus">
  p
    &.el-tooltip
      line-height 1
      margin 0
  .ellipsis-text-tooltip
    max-width 480px
</style>
